export const USER_RANKS = {
    1: { name: '銅章', full_name: '銅章試用員', point:  10000, desc: '歡迎進入試用大平台！好好體驗試用的旅程吧！' },
    2: { name: '銀章', full_name: '銀章試用員', point:  20000, desc: '每一次試用都是對產品的深度探索和嚴格評估！' },
    3: { name: '金牌', full_name: '金牌試用員', point:  50000, desc: '對品質的苛求與創新的探索' },
    4: { name: '大神', full_name: '大神試用員', point: 100000, desc: '每一次試用都是對產品的權威深度剖析' },
};

export const RANK_LIST = Object.keys(USER_RANKS).map((rank) => ({rank, ...USER_RANKS[rank]}));
